/**
 * [众包骑士]
 * @author: Fu Xiaochun
 * @date: 2021-09-01 
 */

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { SearchBox, SearchItem } from '@/components/Layout';
import { XInput, XInputNum, XSelect, XDatePicker, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import KeepAlive from '@/routes/KeepAlive';
import model from '@/reducers/user/rider/model';
import * as api from '@/apis/user/crowdsourcingRider';
import { message, Modal, Button } from 'antd';
import TableContent from './components/TableContent';

function Crowdsourcing(props){

    const [aliveInit, setAliveInit] = useState(false);
    const [riderList, setRiderList] = useState({});
    const [tel, setTel] = useState('');
    const [nickname, setNickname] = useState('');
    const [level, setLevel] = useState({});
    const [riderState, setRiderState] = useState({});
    const [reset, setReset] = useState();
    const page = useRef({pageNum: 1, pageSize: 30});

    const riderLevelList = props.riderLevelList || [];
    const riderStateList = props.riderStateList || [];


    useEffect(()=>{
        props.getRiderLevelList();
        props.getRiderStateList();
        // 设置面包屑
        props.setBreadcrumbPaths(props.match);

    }, []);

    useEffect(()=>{
        if(aliveInit){
            search();
        }
    }, [aliveInit]);

    useEffect(()=>{
        search();
    }, [reset]);

    const initData = (data)=>{
        setAliveInit(true);
        setTel(data.tel);
        setNickname(data.nickname);
        setLevel({...data.level});
        setRiderState({...data.riderState});
    };

    const search = ()=>{
        let params = {
            tel,
            nickname,
            levelValue: level.level,
            status: riderState.code,
            pageNum: page.current.pageNum,
            pageSize: page.current.pageSize
        };
        api.getCrowdsourcingRiderList(params).then(res=>{
            setRiderList(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
        KeepAlive.saveCache({...params, level, riderState});
    };

    const onReset = ()=>{
        setTel('');
        setNickname('');
        setLevel({});
        setRiderState({});
        setReset(Date.now());
    };

    const tableAction = (type, data)=>{
        switch (type){
            case 'detail':
                props.history.push('/home/user/crowdsourcing/detail/'+data.id);
                break;
            case 'available':
                if(data){
                    const disable = data.status == 'DISABLE' || data.status == 'BLACK' ? true : false;
                    if(disable){
                        // 启用
                        api.updateRiderStatus({riderId: data.id, status: 'ENABLE'}).then(res=>{
                            message.success('启用成功');
                            search();
                        }).catch(err=>{
                            message.error(err.message);
                        });
                    }else{
                        // 禁用
                        Modal.confirm({
                            title: '你确定要封禁当前骑士么？',
                            content: null,
                            onOk() {
                                api.updateRiderStatus({riderId: data.id, status: 'DISABLE'}).then(res=>{
                                    message.success('已禁用');
                                    search();
                                }).catch(err=>{
                                    message.error(err.message);
                                });
                            },
                        });
                    }
                }
                break;
            default:
                // nothing to do
        }
        
    };

    const onPageChange = (pageSize, pageNum)=>{
        page.current = {pageNum, pageSize};
        search();
    };

    const addRider = ()=>{
        props.history.push('/home/user/crowdsourcing/addRider');
    };
    
    return (
        <KeepAlive render={(state) => {            
            if (!aliveInit) {
                initData(state);
            }
        }}>
            <div className={styles.flexBoxContainer}>
                <SearchBox>
                    <SearchItem>
                        <XInput
                            label='手机号码'
                            placeholder='请输入手机号码'
                            value={tel}
                            bindThis={setTel}
                            bindName='tel'
                            maxLength={11}
                            mode='number'
                            allowClear={true}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XInput
                            label='姓名'
                            placeholder='请输入姓名'
                            value={nickname}
                            bindThis={setNickname}
                            bindName='nickname'
                            allowClear={true}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='骑士等级'
                            placeholder='请选择骑士等级'
                            renderData={riderLevelList}
                            dataIndex='name'
                            keyIndex='id'
                            value={level.name}
                            bindThis={setLevel}
                            bindName='level'
                            isOptionBindID={true}
                            showSearch={true}
                            allowClear={true}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='骑士状态'
                            placeholder='请选择骑士状态'
                            renderData={riderStateList}
                            dataIndex='value'
                            keyIndex='code'
                            value={riderState.value}
                            bindThis={setRiderState}
                            bindName='riderState'
                            showSearch={true}
                            allowClear={true}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XOKButton
                            label='查询'
                            onClick={search}
                        />
                        <XCancelButton
                            label='重置'
                            onClick={onReset}
                        />
                    </SearchItem>
                </SearchBox>
                <div style={{padding: '10px 0'}}><Button onClick={addRider} type="primary">新建骑士</Button></div>
                <TableContent renderData={riderList} tableAction={tableAction} paginationChange={onPageChange} />
            </div>
        </KeepAlive>
    );
}

Crowdsourcing.propTypes = {
    history: PropTypes.object,//路由对象
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,
    getRiderLevelList: PropTypes.func,
    riderLevelList: PropTypes.array,
    getRiderStateList: PropTypes.func,
    riderStateList: PropTypes.array,
};

const mapStateToProps = (state) => ({
    riderLevelList: state.rider.getRiderLevelList,
    riderStateList: state.rider.getRiderStateList,
});

export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Crowdsourcing);